import "./polyfills"
/* eslint-disable import/first */
import Vue from "vue"
import Vuelidate from "vuelidate"
import NProgress from "nprogress"
/* eslint-enable import/first */
import App from "./App"
import router from "./router"

Vue.use(Vuelidate)

Vue.config.productionTip = false

NProgress.configure({ showSpinner: true })

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
})



// WEBPACK FOOTER //
// ./src/main.js